import React from 'react';

const Cursor: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 36" {...props}>
    <path
      fill="currentColor"
      d="M20.776 23.142h-7.294l3.839 9.562c.267.663-.039 1.406-.65 1.687l-3.38 1.507c-.63.281-1.337-.04-1.604-.683l-3.647-9.08-5.958 6.268c-.794.835-2.082.19-2.082-.904V1.287C0 .134 1.37-.428 2.082.383l19.553 20.57c.789.785.207 2.189-.86 2.189z"
    ></path>
  </svg>
);

export default Cursor;
